module.exports = __webpack_public_path__ + "img/staples-center_la-live2.7307a692.jpg";